import download from "downloadjs";
import classNames from "classnames";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

import { useOutsideClick } from "@ascendnow/shared";
import styles from "./AscReportsListItem.module.scss";
import { CalendarEmptyIcon } from "../AscIcons";
import AscButton from "../AscButton/AscButton";
import AscLink from "../AscLink/AscLink";
import { MoreIcon } from "../AscIcons";
import AscAdminAction from "../AscAdminAction/AscAdminAction";
import { useResponsive } from "../../lib";

dayjs.extend(relativeTime);

export interface AscReportsListItemPropsI {
  title: string;
  date: string;
  reportPath?: string;
  reportFileUrl?: string;
  loading?: boolean;
  onViewClick?: () => void;
  downloadLoading?: boolean;
  onDownloadClick?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
}

function AscReportsListItem({
  title,
  date,
  reportFileUrl,
  reportPath,
  loading,
  onViewClick,
  downloadLoading = false,
  onDownloadClick,
  onEdit,
  onDelete,
}: AscReportsListItemPropsI) {
  const { isExtraLarge } = useResponsive();
  const {
    ref: menuRef,
    isVisible,
    setIsVisible,
  } = useOutsideClick<HTMLDivElement>(false);

  function handleDownloadClick() {
    if (onDownloadClick) {
      onDownloadClick();
    }
    if (!reportFileUrl) {
      return;
    }
    try {
      download(reportFileUrl, title, "application/pdf");
    } catch (error: unknown) {
      console.error(error);
    }
  }

  return (
    <div
      className={classNames(styles.ground, {
        [styles.loading]: loading,
      })}
    >
      <div className={styles.leftContent}>
        <div className={styles.dateContent}>
          <CalendarEmptyIcon className={styles.calendarIcon} />
          <div className={styles.date}>{dayjs(date).format("D MMMM YYYY")}</div>
        </div>
        <div className={styles.title}>{title}</div>
      </div>

      <div className={styles.rightContent}>
        {isExtraLarge && onViewClick && (
          <AscLink
            href={reportPath}
            disabled={!onViewClick}
            innerWrapperTag={null}
          >
            <AscButton variant="secondary" size="small" onClick={onViewClick}>
              View
            </AscButton>
          </AscLink>
        )}
        <AscButton
          size="small"
          onClick={handleDownloadClick}
          loading={downloadLoading}
        >
          {downloadLoading ? "Generating..." : "Download"}
        </AscButton>
        {(onEdit || onDelete) && (
          <div ref={menuRef} className={styles.moreIcon}>
            <MoreIcon
              className={styles.icon}
              onClick={() => setIsVisible(!isVisible)}
            />

            {isVisible && (
              <AscAdminAction
                option1={"Edit"}
                option2={"Delete"}
                clickOption1={onEdit}
                clickOption2={onDelete}
                className={styles.actionBar}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default AscReportsListItem;
